<template>
  <div
      class="position-relative w-100 h-100"
      :class="bgLayoutMap[props.effectMode]"
      :style="{
        maxWidth:`${defaultWidth}px`,
        maxHeight:`${defaultHeight}px`
      }"
  >
    <div class="text_wrap"
         v-if="leftTextContent.obj && Object.keys(leftTextContent.obj).length > 0"
         :class="[
             horizontalPosition[textLayoutData.arr[0].HorizontalAlignment],
             verticalPosition[textLayoutData.arr[0].VerticalAlignment]
            ]"
         :style="{
            textShadow: `3px 3px 10px rgba(0,0,0, ${textShadow})`,
            opacity: `${textOpacity}`
           }"
    >
      <div
          class="d-inline-flex flex-column"
          :class="columnTextAlign[textLayoutData.arr[0].TextAlignment]"
      >
        <div
            class="top_font_wrap top_margin_fix sub_font_size sub_font_family d-inline-flex align-items-center flex-nowrap justify-content-evenly"
            :class="[
                    `sub_font_family_${props.effectMode}_${textType}`,
                    `sub_font_size_${props.effectMode}_${textType}`,
                    `top_margin_fix_${mainFontFamily}_${props.effectMode}_${textType}`
                  ]"
            :style="{ 'color': changeToRgba(textLayoutData.arr[0].FontColors[0]) }"
        >
          <div>{{ leftTextContent.obj.Type }}</div>
        </div>
        <div
            class="medium_font_wrap main_font_size d-inline-flex align-items-center flex-nowrap justify-content-evenly"
            :class="[
                mainFontFamily,
                `main_font_size_${props.effectMode}_${textType}`
            ]"
            :style="{ 'color': changeToRgba(textLayoutData.arr[0].FontColors[1]) }"
        >
          {{ leftTextContent.obj.Value }}
        </div>
        <div
            class="bottom_font_wrap bottom_margin_fix sub_font_size sub_font_family d-inline-flex align-items-center flex-nowrap justify-content-evenly"
            :class="[
                    `sub_font_family_${props.effectMode}_${textType}`,
                    `sub_font_size_${props.effectMode}_${textType}`,
                    `bottom_margin_fix_${mainFontFamily}_${props.effectMode}_${textType}`
                  ]"
            :style="{ 'color': changeToRgba(textLayoutData.arr[0].FontColors[2]) }"
        >
          {{ leftTextContent.obj.Unit }}
        </div>
      </div>
    </div>
    <div
        v-if="rightTextContent.obj && Object.keys(rightTextContent.obj).length > 0"
        class="text_wrap"
         :class="[
             horizontalPosition[textLayoutData.arr[1].HorizontalAlignment],
             verticalPosition[textLayoutData.arr[1].VerticalAlignment]
            ]"
         :style="{
            textShadow: `3px 3px 10px rgba(0,0,0, ${textShadow})`,
            opacity: `${textOpacity}`
           }"
    >
      <div
          class="d-inline-flex flex-column"
          :class="columnTextAlign[textLayoutData.arr[1].TextAlignment]"
      >
        <div
            class="top_font_wrap top_margin_fix sub_font_size sub_font_family d-inline-flex align-items-center flex-nowrap justify-content-evenly"
            :class="[
                    `sub_font_family_${props.effectMode}_${textType}`,
                    `sub_font_size_${props.effectMode}_${textType}`,
                    `top_margin_fix_${mainFontFamily}_${props.effectMode}_${textType}`
                  ]"
            :style="{ 'color': changeToRgba(textLayoutData.arr[1].FontColors[0]) }"
        >
          <div> {{ rightTextContent.obj.Type }}</div>
        </div>
        <div
            class="medium_font_wrap main_font_size d-inline-flex align-items-center flex-nowrap justify-content-evenly"
            :class="[
                mainFontFamily,
                `main_font_size_${props.effectMode}_${textType}`
            ]"
            :style="{
            'color': changeToRgba(textLayoutData.arr[1].FontColors[1]),
          }"
        >
          {{ rightTextContent.obj.Value }}
        </div>
        <div
            class="bottom_font_wrap bottom_margin_fix sub_font_size sub_font_family d-inline-flex align-items-center flex-nowrap justify-content-evenly"
            :class="[
                    `sub_font_family_${props.effectMode}_${textType}`,
                    `sub_font_size_${props.effectMode}_${textType}`,
                    `bottom_margin_fix_${mainFontFamily}_${props.effectMode}_${textType}`
                  ]"
            :style="{ 'color': changeToRgba(textLayoutData.arr[1].FontColors[2]) }"
        >
          {{ rightTextContent.obj.Unit }}
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import defaultValue from "@/utils/defaultValue";

import {ref, reactive, watchEffect, watch} from 'vue'
import changeToRgba from '@/utils/globalFunc'
import textModeTool from "@/utils/textModeTool";

const {defaultWidth, defaultHeight} = defaultValue()

const {
  bgLayoutMap,
  horizontalPosition,
  verticalPosition,
  columnTextAlign,
  initMainFontFamily
} = textModeTool()

const props = defineProps(["textData", "sensorValue", 'effectMode'])
const texts = reactive(props.textData)
const textType = ref('')

const sensorJsonObj = reactive({obj: props.sensorValue}) // 取得sensor資料
const textLayoutData = reactive({arr: []})
const textContent = reactive({arr: []})
const leftTextContent = reactive({obj: {}})
const rightTextContent = reactive({obj: {}})

const mainFontFamily = ref('')

const textShadow = ref('35%')
const textOpacity = ref('100%')

const sensorsSelectedValue = ref([])

const processTextContent = (sensorsSelected, sensorJsonObj) => {
  textContent.arr = []
  for (const sensor of sensorsSelected) {
    textContent.arr.push(sensorJsonObj[sensor]);
  }
}

watchEffect(() => {
  const {
    Type,
    Layout,
    Sensors: sensorsSelected
  } = texts

  if (Type === 'None' || Type === undefined) {
    textLayoutData.arr = []
    return false
  }
  textType.value = Type
  sensorsSelectedValue.value = sensorsSelected

  // 取得文字對齊位置
  textLayoutData.arr = Layout

  const {
    Shadow,
    Opacity,
    FontFamily
  } = Layout[0]
  textShadow.value = parseInt(Shadow) >= 0 ? `${Shadow}%` : '35%'
  textOpacity.value = parseInt(Opacity) >= 0 ? `${Opacity}%` : '100%'
  if (FontFamily && FontFamily !== '') mainFontFamily.value = `font_family_${FontFamily}`
  else mainFontFamily.value = initMainFontFamily(props.effectMode)

  // 取得資料
  processTextContent(sensorsSelectedValue.value, sensorJsonObj.obj)
  leftTextContent.obj = textContent.arr[0] ? textContent.arr[0] : {}
  rightTextContent.obj = textContent.arr[1] ? textContent.arr[1] : {}

})
</script>
